var React = require('react');

function MobileDownloadIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":".5","fillRule":"evenodd","clipRule":"evenodd","d":"M8 1a1 1 0 0 1 1-1h7v7a1 1 0 1 1-2 0V3.414l-6.793 6.793a1 1 0 0 1-1.414-1.414L12.586 2H9a1 1 0 0 1-1-1zm7.302 10.272c.28-.623-.22-1.272-.904-1.272-.443 0-.83.284-1.029.68a6 6 0 1 1-8.05-8.05C5.716 2.432 6 2.045 6 1.602 6 .918 5.351.418 4.728.698A8.002 8.002 0 0 0 8 16a8.002 8.002 0 0 0 7.302-4.728z","fill":"#55FF8A"}));
}

MobileDownloadIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = MobileDownloadIcon;

MobileDownloadIcon.default = MobileDownloadIcon;
